export const origin_storage = 'https://api.kkmeal.com/v1/mgr/uploader/image/';

export const getStorageUrl = (key) => {
  if (/^https?:\/\//.test(key)) {
    return key;
  } else {
    return `${origin_storage}${key}`;
  }
};
